import { signatureFromParams } from "../../../modules/EquivalenceHelpers";

export const signatureAuthor = signatureFromParams([
  "data_stream_id",
  "start_time",
  "end_time"
]);
